import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import CreateEditContent from './CreateEditContent';
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { Colors } from '~/config/Colors';
import { SLEditModal } from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';

export default function Projetos() {
  const [data, setData] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [clientes, setClientes] = useState([]);
  const [analistas, setAnalistas] = useState([]);

  useEffect(() => {
    async function handleRequests() {
      api
        .get('/signed/empresa/gestorprojeto/cliente/clientes', { params: { ativo: 1 } })
        .then(response => setClientes(response.data));

      api
        .get('/signed/empresa/gestorprojeto/gerencia/analistas', { params: { ativo: 1 } })
        .then(response => setAnalistas(response.data));
    }

    handleRequests();
  }, []);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-pj"
            requests={{
              findAll: () =>
                api.get('/signed/empresa/gestorprojeto/projetos', {
                  params: { tipoProjeto: 'S' },
                }),
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/projeto', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/gestorprojeto/projeto', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            topMain={false}
            informationPage={{
              title: 'Projetos',
              subTitle: 'Crie e Gerencie os Projetos',
              icone: 'menu-projetos',
              menu: true,
            }}
            tabFilter={{
              initial: { ativo: true },
              tabAtivo: 1,
              list: [
                {
                  corDestaque: localStorage.getItem('tema') == 'E' ? '#9A3636' : '#e68282',
                  corFundo: Colors?.Color8,
                  title: 'Desativado',
                  value: { ativo: false },
                },
                {
                  corDestaque: Colors?.Color4,
                  corFundo: Colors?.Color8,
                  title: 'Ativo',
                  value: { ativo: true },
                },
              ],
            }}
            selects={[
              {
                list: clientes,
                value: 'id',
                label: 'nomeFantasia',
                outLabel: 'Todos os Clientes',
                filter: 'idCliente',
              },
              {
                list: analistas,
                value: 'id',
                label: 'nome',
                outLabel: 'Todos os Analistas',
                filter: 'atividadesAnalista.idAnalista',
              },
            ]}
            inputs={[
              { filter: 'titulo', label: 'Titulo' },
              { filter: 'id', label: 'Id' },
              { filter: 'cliente.nomeFantasia', label: 'Cliente' },
            ]}
          >
            <SLEditModal menu={true} title="Atualizar Projeto" setter={setMountedData}>
              {mountedData && <CreateEditContent {...{ mountedData }} />}
            </SLEditModal>

            <CustomBodyContent {...{ data }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
